<template>
  <AppDialog
    :model-value="modelValue"
    :persistent="false"
    title="Manage Roles"
    max-width="900px"
    @update:model-value="$emit('update:modelValue', $event)"
    @close="$emit('update:modelValue', false)"
  >
    <v-card-text>
      <v-row
        v-for="role in workingRoles"
        :key="role.id"
        class="pt-4"
      >
        <v-col cols="4">
          <v-text-field
            v-model="role.name"
            label="Role Name"
            variant="outlined"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="role.scopes"
            :items="scopeOptions"
            item-title="title"
            item-value="value"
            label="Permissions"
            variant="outlined"
            density="compact"
            hide-details
            multiple
            chips
            closable-chips
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex align-center"
        >
          <v-btn
            color="primary"
            :disabled="!role.name || savingId === role.id"
            @click="saveRole(role)"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-6" />

      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1">
            Add New Role
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="newRole.name"
            label="Role Name"
            variant="outlined"
            density="compact"
            hide-details
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="newRole.scopes"
            :items="scopeOptions"
            item-title="title"
            item-value="value"
            label="Permissions"
            variant="outlined"
            density="compact"
            hide-details
            multiple
            chips
            closable-chips
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex align-center"
        >
          <v-btn
            color="primary"
            :disabled="!newRole.name || savingNew"
            @click="addRole"
          >
            Add
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('update:modelValue', false)">
        <v-icon>mdi-close</v-icon>
        Close
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppDialog from "@/components/AppDialog";

const SCOPE_OPTIONS = [
  { title: "Sightings - Read", value: "sightings:read" },
  { title: "Sightings - Write", value: "sightings:write" },
  { title: "Whales - Read", value: "whales:read" },
  { title: "Whales - Write", value: "whales:write" },
  { title: "Images - Read", value: "images:read" },
  { title: "Images - Write", value: "images:write" },
  { title: "Users - Read", value: "user:read" },
  { title: "Users - Write", value: "user:write" },
  { title: "Reports - Read", value: "reports:read" },
  { title: "Reports - Write", value: "reports:write" },
];

export default {
  components: { AppDialog },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      scopeOptions: SCOPE_OPTIONS,
      workingRoles: [],
      newRole: { name: "", scopes: [] },
      savingId: null,
      savingNew: false,
    };
  },
  computed: {
    ...mapGetters({
      roles: "users/roles",
    }),
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.syncWorkingRoles();
        this.newRole = { name: "", scopes: [] };
      }
    },
    roles() {
      this.syncWorkingRoles();
    },
  },
  methods: {
    ...mapActions({
      createRole: "users/createRole",
      updateRole: "users/updateRole",
    }),
    syncWorkingRoles() {
      this.workingRoles = this.roles.map((role) => ({
        id: role.id,
        slug: role.slug,
        name: role.name,
        scopes: (role.scopes || []).filter((s) => s !== "me"),
      }));
    },
    async saveRole(role) {
      this.savingId = role.id;
      await this.updateRole({
        roleId: role.id,
        role: { name: role.name, scopes: ["me", ...role.scopes] },
      });
      this.savingId = null;
    },
    async addRole() {
      this.savingNew = true;
      await this.createRole({
        name: this.newRole.name,
        scopes: ["me", ...this.newRole.scopes],
      });
      this.newRole = { name: "", scopes: [] };
      this.savingNew = false;
    },
  },
};
</script>

<style scoped>
</style>
